<template>
    <v-card :min-width="Modal.Processamento.larguraMinima" :max-width="Modal.Processamento.larguraMaxima">
        <v-card-title class="primary modal-title" primary-title>
            <span>{{title}}</span>
            <v-btn flat depressed @click="fecharModal">
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="az-form-content pa-0">
            <p class="subtitulo-destaque" v-if="value.lotes.length > 0">
                Grupo de Itens
            </p>

            <v-checkbox v-if="value.lotesDisponiveis.length > 0"
                        v-model="todosLotes"
                        label="Todos"
                        class="alinhar-todos"
                        color="primary"
                        @change="selecionarTodosLotes"/>

            <v-layout wrap align-center white class="area-item" v-if="value.lotesDisponiveis.length > 0">
                <v-flex xs6 sm2 d-flex v-for="(lote, index) in value.lotesDisponiveis" :key="index">
                    <v-checkbox v-model="lote.selecionado"
                                @change="verificarLoteSelecionado(lote)"
                                class="checkbox-item" color="primary">
                        <template v-slot:label>
                            {{lote.descricao}}
                        </template>
                    </v-checkbox>
                </v-flex>
            </v-layout>

            <v-expansion-panel v-if="value.lotesIndisponiveis.length > 0" class="painel-item">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div class="painel-titulo mr-2">Demais Grupo de Itens ({{value.lotesIndisponiveis.length}})</div>
                    </template>
                    <v-card>
                        <v-layout wrap align-center white class="pt-3">
                            <v-flex xs6 sm3 d-flex v-for="(lote, id) in value.lotesIndisponiveis" :key="id">
                                <p class="descricao-item">
                                    {{lote.descricao}}
                                    <small>- ({{lote.situacao | azEnum(situacoesItensELotes)}})</small>
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <p class="subtitulo-destaque" v-if="value.itens.length > 0">
                Itens
            </p>

            <v-checkbox v-if="value.itensDisponiveis.length > 0"
                        v-model="todosItens"
                        label="Todos"
                        color="primary"
                        class="alinhar-todos"
                        @change="selecionarTodosItens"/>

            <v-layout wrap align-center white class="area-item" v-if="value.itensDisponiveis.length > 0">
                <v-flex xs6 sm2 d-flex v-for="(item, index) in value.itensDisponiveis" :key="index">
                    <v-checkbox v-model="item.selecionado"
                                @change="verificarItemSelecionado(item)"
                                class="checkbox-item" color="primary">
                        <template v-slot:label>
                           {{item.identificacaoSequencial}}
                        </template>
                    </v-checkbox>
                </v-flex>
            </v-layout>

            <v-expansion-panel class="painel-item" v-if="value.itensIndisponiveis.length > 0">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div class="painel-titulo mr-2">Demais Itens ({{value.itensIndisponiveis.length}})</div>
                    </template>
                    <v-card>
                        <v-layout wrap align-center white class="pt-3">
                            <v-flex xs6 sm3 d-flex v-for="(item, id) in value.itensIndisponiveis" :key="id">
                                <p class="descricao-item">
                                    ITEM {{item.sequencia}}
                                    <small>- ({{item.situacao | azEnum(situacoesItensELotes)}})</small>
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <p class="sem-resultado" v-if="value.itens.length === 0 && value.lotes.length === 0">
                Não há itens para esta compra direta.
            </p>

            <v-divider/>

            <v-layout wrap align-center white class="pa-3"
                      v-if="value.itens.length > 0 || value.lotes.length > 0">
                <v-flex xs12 sm12 d-flex>
                    <v-textarea :name="'Motivo ' + title" label="Motivo" v-model="valor.motivo" rows="3"
                                placeholder="Ex. Falta de lances" maxlength="1000"
                                :error-messages="errors.collect('Motivo ' + title)"
                                :key="'Motivo ' + title"
                                v-validate="'required'" :counter="1000"/>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-divider/>

        <v-card-actions class="px-3 py-2">
            <v-btn color="botao-cancelar-color" outline flat @click="fecharModal">
                Fechar
            </v-btn>
            <v-spacer/>
            <v-btn color="primary" depressed @click="salvarAlteracao">
                Confirmar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { Modal, situacoesItensELotes} from '@/core/constants'

export default {
    name: 'ModalAlterarSituacaoLoteEItem',
    props: {
        value: {
            required: true
        },
        title: {
            required: true
        }
    },
    data() {
        return {
            valor: {
                required: true,
                motivo: ''
            },
            todosLotes: false,
            todosItens: false,
            listaDeItensSelecionados: [],
            listaDeLotesSelecionados: [],
            situacoesItensELotes,
            Modal
        }
    },
    methods: {
        async salvarAlteracao() {
            await this.validarCamposObrigatorios()
            const objParaAlterar = {
                itens: this.listaDeItensSelecionados,
                lotes: this.listaDeLotesSelecionados,
                motivo: this.valor.motivo,
            }
            this.$emit('salvarAlteracaoSituacao', objParaAlterar)
            this.valor = {}
        },
        verificarItemSelecionado(item) {
            const index = this.verificarSeItemEstaNaLista(item.id)
            if (index === -1) {
                item.selecionado = true
                this.listaDeItensSelecionados.push(item.id)
            } else {
                item.selecionado = false
                this.listaDeItensSelecionados.splice(index, 1)
            }
            this.verificarSituacaoDeTodosItens()
        },
        verificarLoteSelecionado(lote) {
            let index = this.verificarSeLoteEstaNaLista(lote.id)
            if (index === -1) {
                lote.selecionado = true
                this.listaDeLotesSelecionados.push(lote.id)
            } else {
                lote.selecionado = false
                this.listaDeLotesSelecionados.splice(index, 1)
            }
            this.verificarSituacaoDeTodosLotes()
        },
        selecionarTodosLotes() {
            this.value.lotesDisponiveis.forEach(lote => {
                lote.selecionado = this.todosLotes
                const index = this.verificarSeLoteEstaNaLista(lote.id)
                if (this.todosLotes && index === -1) {
                    this.listaDeLotesSelecionados.push(lote.id)
                } else if (!this.todosLotes && index !== -1) {
                    this.listaDeLotesSelecionados.splice(index, 1)
                }
            })
        },
        selecionarTodosItens() {
            this.value.itensDisponiveis.forEach(item => {
                item.selecionado = this.todosItens
                const index = this.verificarSeItemEstaNaLista(item.id)
                if (index === -1 && this.todosItens) {
                    this.listaDeItensSelecionados.push(item.id)
                } else if (!this.todosItens && index !== -1) {
                    this.listaDeItensSelecionados.splice(index, 1)
                }
            })
        },
        verificarSituacaoDeTodosItens() {
            let qtdItemSelecionado = 0
            this.value.itensDisponiveis.forEach(item => {
                if (item.selecionado) {
                    qtdItemSelecionado++
                }
            })
            this.todosItens = qtdItemSelecionado === this.value.itensDisponiveis.length
        },
        verificarSituacaoDeTodosLotes() {
            let qtdLoteSelecionado = 0
            this.value.lotesDisponiveis.forEach(lote => {
                if (lote.selecionado) {
                    qtdLoteSelecionado++
                }
            })
            this.todosLotes = qtdLoteSelecionado === this.value.lotesDisponiveis.length
        },
        async validarCamposObrigatorios() {
            const estaValidado = await this.$validator.validate('Motivo ' + this.title)
            const loteEItemSelecionado = this.validarCampoSelecionado()
            if (!estaValidado && !loteEItemSelecionado) {
                throw new Error('É necessário selecionar um item e informar o motivo para realizar a operação.')
            }
            if (!loteEItemSelecionado) {
                throw new Error('É necessário selecionar um item para realizar a operação.')
            }
            if (!estaValidado) {
                throw new Error('É necessário informar um motivo para realizar a operação.')
            }
        },
        validarCampoSelecionado() {
            return this.listaDeItensSelecionados.length > 0 || this.listaDeLotesSelecionados.length > 0
        },
        fecharModal() {
            this.valor = {}
            this.todosLotes = false
            this.todosItens = false
            this.$emit('fecharModalAlteracao')
        },
        verificarSeItemEstaNaLista(id) {
            return this.listaDeItensSelecionados.findIndex(item => item === id)
        },
        verificarSeLoteEstaNaLista(id) {
            return this.listaDeLotesSelecionados.findIndex(lote => lote === id)
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .subtitulo-destaque
        color var(--v-primary-base)
        font-weight 600
        border-top 1px solid rgba(0, 0, 0, .12)
        border-bottom 1px solid rgba(0, 0, 0, .12)
        padding 16px
        margin-bottom 0
        font-size: 15px;

    .alinhar-todos
        padding 0 16px

    .checkbox-item, .alinhar-todos
        height 25px

    .checkbox-item small
        font-size 12px
        text-transform lowercase

    .area-item
        padding 0 16px 18px
        justify-items center
        justify-content flex-start
        flex-wrap wrap

    .descricao-item, .sem-resultado
        color #777

    .descricao-item
        margin 0 16px 16px

    .sem-resultado
        margin 16px
        text-align center

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base)
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important

    .acoes
        padding 20px 0 !important

    .painel-item
        box-shadow none
        border-top 1px solid rgba(0, 0, 0, .12)

    .painel-titulo
        color #777
        text-align right
</style>
